import {
    isCatalogImportTab,
    type CatalogImportTab,
} from '@/pages/catalogImport/store';

/** The address parameter that holds the Products table's tab: `?tab=restock`. */
export const IMPORT_TAB_PARAM = 'tab';

/** The tab with no parameter, and the one an unknown value falls back to. */
export const DEFAULT_IMPORT_TAB: CatalogImportTab = 'all';

/** The tab the address names; All when it names none, or one the table does not have. */
export const readImportTab = (params: URLSearchParams): CatalogImportTab => {
    const value = params.get(IMPORT_TAB_PARAM);
    return isCatalogImportTab(value) ? value : DEFAULT_IMPORT_TAB;
};

/**
 * The address with `tab` selected and every other parameter kept. All, the
 * default, leaves the parameter out, so a plain step address reads All.
 */
export const writeImportTab = (
    params: URLSearchParams,
    tab: CatalogImportTab,
): URLSearchParams => {
    const next = new URLSearchParams(params);
    if (tab === DEFAULT_IMPORT_TAB) {
        next.delete(IMPORT_TAB_PARAM);
    } else {
        next.set(IMPORT_TAB_PARAM, tab);
    }
    return next;
};
